import { useForm } from 'react-hook-form';
import { LoadingButton } from '@mui/lab';
import { Box, Stack } from '@mui/material';

import FormProvider, { RHFSelect } from '@/commons/hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { Icon } from '@iconify/react';
import { useTheme } from '@mui/material/styles';
import { useMemo } from 'react';
import { translates } from '@/utils';
import { useQuery } from '@tanstack/react-query';
import { getRoles } from '@/services';
import { changeRolSchema } from './validations';
import { defaultValuesForm } from './initial-values';

type Props = {
  isLoading?: boolean;
  onSave: (values: any) => void;
};

export default function PopChangeRol({ onSave, isLoading }: Props) {
  const { palette } = useTheme();

  const { data: dataRols } = useQuery({
    queryKey: ['rols'],
    queryFn: getRoles,
  });

  const defaultValues = useMemo(
    () => defaultValuesForm({}),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const methods = useForm<any>({
    defaultValues,
    resolver: yupResolver(changeRolSchema),
  });

  const { reset, handleSubmit } = methods;

  const onSubmit = async (data: any) => {
    try {
      await onSave({ role: data.rol });
      reset();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Box sx={{ justifyContent: 'center', display: 'flex', mt: 2 }}>
        <Icon icon="material-symbols:change-circle-outline" color={palette.secondary.main} width={100} />
      </Box>
      <Box mt={3} py={3}>
        <RHFSelect native name="rol" label={translates.rol} fullWidth>
          <option value="" />
          {dataRols?.map?.((role: any) => (
            <option key={role.id} value={role.id}>
              {role.name}
            </option>
          ))}
        </RHFSelect>
      </Box>

      <Stack sx={{ justifyContent: 'center', my: 2 }}>
        <LoadingButton type="submit" variant="outlined" loading={isLoading}>
          Guardar cambios
        </LoadingButton>
      </Stack>
    </FormProvider>
  );
}
